// extracted by mini-css-extract-plugin
export default {"shortlistButton":"styles_shortlistButton__cpp+R","unshortlistButton":"styles_unshortlistButton__n8Mdc"};